module.exports = __webpack_public_path__ + "img/_box_email.300b8134.svg";